<template>
  <div class="modal" :class="{ 'is-active': showModal }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Pagar {{ table.type }} {{ table.name }} | {{ currency(totalDue) }}
        </p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <div class="label">Efectivo</div>
          <div class="control has-icons-left has-addons">
            <input
              type="number"
              min="0"
              step="1"
              pattern="[0-9]*"
              v-model="cash"
              placeholder="0"
              @keyup.enter="checkDone"
              @keyup.esc="close"
              class="input is-primary is-large has-text-right"
              autofocus
            />
            <span class="icon is-left">
              <span class="material-symbols-outlined">attach_money</span>
            </span>
          </div>
        </div>
        <p class="is-size-1">Vueltas: {{ currency(change) }}</p>
        <p>Agregados a la mesa</p>
        <div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Fecha y hora</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="h in due_history"
                v-bind:key="h.timestamp"
                :class="{ 'has-text-danger is-removed': h.is_deleted }"
              >
                <td>{{ formatDate(h.timestamp) }}</td>
                <td class="has-text-right">{{ currency(h.due) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="has-text-right">
                  <strong>{{ currency(totalDue) }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="checkDone">
          <span class="material-symbols-outlined">attach_money</span>&nbsp;Pagar
        </button>
        <button class="button is-info" @click="close">
          <span class="material-symbols-outlined">close</span>&nbsp;Cancelar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
export default {
  name: "TableBucketCheck",
  data() {
    return {
      showAdd: true,
      ammount: null,
      cash: null,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
    table: {
      type: Object,
    },
    due_history: {
      type: Array,
    },
  },
  computed: {
    totalDue() {
      return this.due_history
        .filter((h) => !h.is_deleted)
        .reduce((a, h) => a + h.due, 0);
    },
    change() {
      let ch = parseFloat(this.cash || 0) - this.totalDue;
      if (ch < 0) {
        return 0;
      }
      return ch;
    },
  },
  methods: {
    checkDone() {
      this.$emit("checkDone");
    },
    close() {
      this.$emit("closeModal");
    },
    currency(val) {
      let cur = Intl.NumberFormat("es-CO");
      return `$ ${cur.format(val)}`;
    },
    formatDate(date) {
      return format(date, "p");
    },
  },
  mounted() {
    let input = document.querySelector("[autofocus]");
    if (input) {
      input.focus();
    }
  },
};
</script>

<style scoped>
table > tbody {
  height: 3rem;
  overflow-y: scroll;
}
.modal-background {
  background-color: rgba(10, 10, 10, 0.4);
}
.is-removed {
  text-decoration: line-through;
}
</style>
